import { IUploadInfo } from 'views/bulkUpload/UploadCatalog/content/uploadCatalogInfo';

export const downloadUploadInfo: IUploadInfo = {
  title: 'Sube la plantilla actualizada',
  description: (
    <>
      Sube la plantilla en formato <strong>Excel o Google Sheets</strong> para continuar con la carga masiva. Haz clic
      en “Subir plantilla” o arrástralo aquí. También puedes omitir este paso y subirlo después desde el Cargue masivo.
    </>
  ),
  icon: 'document'
};

export const uploadTemplateInfoWithErrors = (errorTemplateURL: string): IUploadInfo => ({
  title: 'Sube la plantilla sin errores',
  description: (
    <div>
      <div style={{ margin: 0 }}>
        Sube nuevamente la plantilla una vez que resuelvas los errores. ¿No se descargó correctamente el archivo?
      </div>
      <a href={errorTemplateURL} style={{ textDecoration: 'underline' }}>
        Descargar plantilla con errores
      </a>
    </div>
  ),
  icon: 'document'
});

export const templateUploadedInfo = (success: number, total: number): IUploadInfo => ({
  title: 'Tu plantilla ha sido cargada',
  description: (
    <>
      Se subieron{' '}
      <strong>
        {success} de {total} cotizaciones correctamente.
      </strong>{' '}
      Ahora puedes volver al Cargue masivo para realizar otro cargue o ir a Cotizaciones para revisar las cotizaciones
      cargadas
    </>
  ),
  icon: 'checkCircle',
  fontSize: '1.4rem'
});

export const templateWithErrorsInfo = (success: number, total: number): IUploadInfo => ({
  title: 'Revisa y confirma la información',
  description: (
    <>
      Se subieron{' '}
      <strong>
        {success} de {total} cotizaciones.
      </strong>{' '}
      Para procesar la carga, corrige los errores señalados o elimina las filas que presentan conflictos."
    </>
  ),
  icon: 'alertTriangleWarning',
  fontSize: '1.4rem'
});
